module.exports = __webpack_public_path__ + "img/8.3fb4b1f0.jpg";